export class DashboardDocumentHtml {
    documentskin(){
        return `
            <div class="container-layout full-height">
                <div class="container-column">
                    <div class="container-body">
                        <button id="upload-doc-btn" class="btn-primary">Upload Document</button>
                        <div class="table-responsive">
                            <table class="has-min-width border-table">
                            <thead>
                                <tr>
                                <th>Name</th>
                                <th>Created</th>
                                <th>Last Update</th>
                                <th>Link Type</th>
                                <th>Source</th>
                                <th>Last Modifier</th>
                                <th>Author</th>
                                <th>Size</th>
                                <th>Tags</th>
                                <th>Download</th>
                                <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-left">LOT Mua Sch</td>
                                    <td class="text-left">22/08/2025</td>
                                    <td class="text-left">22/08/2025</td>
                                    <td class="text-left">plant</td>
                                    <td class="text-left">Site/PPC</td>
                                    <td class="text-left">tshekaru</td>
                                    <td class="text-left">gchrisis</td>
                                    <td class="text-left">177.5kb</td>
                                    <td class="text-left">report, monthly</td>
                                    <td class="text-left"><button class="btn-icon"><span class="iconify" data-icon="mdi:download"></span></button></td>
                                    <td class="text-left"><button class="btn-icon btn-danger"><span class="iconify" data-icon="mdi:delete"></span></button></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
